export const createdDateFormat = (createdAt, lng) => {
  var options = {
    year: "numeric",
    month: "long",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };
  const createdDate = new Date(createdAt);
  const dtf = new Intl.DateTimeFormat(lng, options);
  const [
    { value: mo },
    ,
    { value: da },
    ,
    { value: ye },
    ,
    { value: ho },
    ,
    { value: mi }
  ] = dtf.formatToParts(createdDate);

  return `${mo} ${da} ${ye}, ${ho}:${mi}`;
};

export const updatedDateFormat = (updatedAt, lng) => {
  var options = {
    year: "numeric",
    month: "long",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };
  const updatedDate = new Date(updatedAt);
  const dtf = new Intl.DateTimeFormat(lng, options);
  const [
    { value: mo },
    ,
    { value: da },
    ,
    { value: ye },
    ,
    { value: ho },
    ,
    { value: mi }
  ] = dtf.formatToParts(updatedDate);

  return `${mo} ${da} ${ye}, ${ho}:${mi}`;
};



// WEBPACK FOOTER //
// ./src/utils/dashboardList.js